import { make } from 'vuex-pathify'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import axios from 'axios'

const state = {
  inventory: {},
  inventories: {
    data: [],
    count: 0,
    limit: 50,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['name'],
    sortDesc: [false],
  },

  loading: false,
  type: 'add',
  dialog: false,
  dialogView: false,
}

const mutations = make.mutations(state)

const actions = {
  view: ({ state }) => {
    state.type = 'add'
    state.dialogView = true
    state.filter = {
      page: 1,
      itemsPerPage: 25,
      sortBy: ['name'],
      sortDesc: [false],
    }
  },

  add: ({ state }) => {
    state.inventory = {
      name: 'Principal',
      companyId: store.get('authStore@currentCompany').id,
    }
    state.type = 'add'
    state.dialog = true
  },

  edit: ({ state }, id) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/inventory/${id}`)
      .then(res => {
        state.inventory = res.data

        state.type = 'edit'
        state.dialog = true
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  save: async ({ state }, inventory) => {
    const id = inventory.id
    const method = id ? 'put' : 'post'

    if (method === 'post') {
      const res = await store.dispatch('inventoryStore/getSequence', inventory.productId)
      inventory.sequence = Number(res.data) + 1
    }

    state.loading = true
    return axios[method](`${process.env.VUE_APP_API_URL}/inventory/${id || ''}`, inventory)
      .then((res) => {
        state.dialog = false
        store.dispatch('inventoryStore/get')
        showSuccess('Estoque salvo com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/inventory?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.inventories = res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getById: (context, id) => axios.get(`${process.env.VUE_APP_API_URL}/inventory/${id}`).catch(showError),

  getSequence: (context, productId) => axios.get(`${process.env.VUE_APP_API_URL}/inventory-sequence/${productId}`).catch(showError),

  remove: ({ state }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/inventory/${id}`)
      .then(_ => {
        store.dispatch('inventoryStore/get')
        showSuccess('Cliente excluído com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
